<div class="legend-container" *ngIf="appService.theme$ | async as theme">
    <div class="note-content">The Flight List is listed by contractual month.  
      See FAQ's for more information on contractual month.
    </div>
     <img class="legend-image"
        [src]="theme === 'light' ? 'assets/flightItemLegend_Light.png' : 'assets/flightItemLegend_Dark.png'"
        alt="Flight Item"
        [style]="{'padding-top': '10px'}"
        />
        <ol>
          <li *ngFor="let item of legendItems; let i = index">
            <div class="item-content">{{item}}</div>
          </li>
        </ol>
</div>
